import { render, staticRenderFns } from "./ProfileStatistics.vue?vue&type=template&id=66b55869&scoped=true&"
import script from "./ProfileStatistics.vue?vue&type=script&lang=js&"
export * from "./ProfileStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStatistics.vue?vue&type=style&index=0&id=66b55869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b55869",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VDivider,VRow})
